import React from 'react'
import { Translate } from "react-redux-i18n";
import PrypoolProductDescription from '../../components/PrypoolProduct/PrypoolProductDescription';

export default function AvailableProductsContainer({available_products, selected_products, productClicked}) {
    
    if(!available_products) return null;
    
    return (
        <div>
            <h1><Translate value='prypool.available_products' /></h1>

            <div className="prylpool-products-listing">
                {available_products.map(product=>(
                    <PrypoolProductDescription product={product} selected_products={selected_products} key={product.id} selectProduct={productClicked} />
                ))}
            </div>
        </div>
    )
}
